<script>
    import { getViewData } from '../../modules/view-data';

    export default {
        name: 'microsite-mixin',

        computed: {
            microsite() {
                return getViewData('microsite');
            },

            isMicrosite() {
                return Boolean(this.microsite);
            },

            platformEmail() {
                return this.microsite
                    ? this.microsite.support_email
                    : 'support@yourparkingspace.co.uk';
            },
        },
    };
</script>
